export { default } from 'common/models/module';
